import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { showDrawer } from "@app/store/layoutSlice";
import { isValidVinOrPlate, normalizeVinOrPlate } from "@entities/history";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CheckHistoryPreviewProps } from "./types";
import classes from "./check-history-preview.module.scss";

export const CheckHistoryPreview = ({
    initialVin,
    showMyReportsLink,
    balance = 0
}: CheckHistoryPreviewProps) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const [vin, setVin] = useState(initialVin);
    const [error, setError] = useState(false);

    const emptyBalance = balance === 0;
    const wordBalance = balance === 1 ? "отчёт" : balance < 5 ? "отчёта" : "отчётов";

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setVin(value);

        if (error) setError(false);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const value = normalizeVinOrPlate(vin);
        if (!isValidVinOrPlate(value)) {
            setError(true);
            return;
        }

        setError(false);
        router.push(`${RouterConfig.HISTORY}/${value}`);
    };

    return (
        <form className={classes["check-preview"]} onSubmit={handleSubmit}>
            <p className={classes["check-preview__title"]}>
                Введите госномер, VIN или номер кузова
            </p>
            <input
                className={classes["check-preview__input"]}
                value={vin}
                onChange={handleChange}
                placeholder={"Госномер, VIN или номер кузова"}
            />
            {error && (
                <div className={classes["check-preview__error"]}>
                    Неправильный госномер, VIN или номер кузова
                </div>
            )}
            <button className={classes["check-preview__button"]} type="submit">
                Проверить
            </button>
            {!emptyBalance && (
                <div className={classes["check-preview__balance"]}>
                    Осталось {balance} {wordBalance} в пакете
                </div>
            )}
            {showMyReportsLink && (
                <a
                    className={classes["check-preview__archive"]}
                    href={RouterConfig.HISTORY_MY_REPORTS}
                >
                    Мои отчеты
                </a>
            )}
            <button
                className={classes["check-preview__example"]}
                type="button"
                onClick={() => dispatch(showDrawer())}
            >
                Пример отчета
            </button>
        </form>
    );
};